import * as PIXI from "pixi.js";
import BaseButton from "./BaseButton";
import { ButtonBounds } from "../../types/Interface";
import { BetAmountStatus, Sounds } from "../../types/Enum";


export default class PlusButton extends BaseButton {
  private con;

  constructor(container: PIXI.Container, bounds: ButtonBounds) {
    super("plus", Sounds.click1);
    Object.assign(this, bounds);
    this.con = container;
    this.addToContainer = this.addContainer;
    this.EventBus.on(this.EnumEventBus.betAmountStatus, (status: BetAmountStatus) => this.setAvaible(status))
  }
  setAvaible(status: BetAmountStatus) {
    if (status == BetAmountStatus.max) {
      this.interactive = false;
      this.exchangeTexture(this.pressed);
    } else if (status == BetAmountStatus.nonExtreme) {
      this.interactive = true;
      this.exchangeTexture(this.regular);
    }
  }
  handlePress() {
    this.EventBus.emit(this.EnumEventBus.increaseAmount)
  }

  addContainer() {
    this.con.addChild(this);
  }
}